import { BlockUIModule }           from 'ng-block-ui';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule }            from '@angular/common';
import { FormsModule }             from '@angular/forms';
import { HttpClientModule }        from '@angular/common/http';
import { NgModule }                from '@angular/core';
import {
  NgbAlertModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModalConfig,
  NgbModalModule,
  NgbNavModule
}                                  from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule }         from '@ngx-translate/core';
import { UIRouterUpgradeModule }   from '@uirouter/angular-hybrid';

import { ComponentsModule       } from './components/components.module';
import { ControlsModule         } from './controls/controls.module';
import { DirectivesModule       } from './directives/directives.module';
import { PipesModule            } from './pipes/pipes.module';
import { ValidatorsModule       } from './validators/validators.module';

@NgModule({
  exports: [
    // Angular
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,

    // Third Party
    BlockUIModule,
    NgbAlertModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    TranslateModule,
    UIRouterUpgradeModule,

     // Custom
    ComponentsModule,
    ControlsModule,
    DirectivesModule,
    PipesModule,
    ValidatorsModule
  ],
  imports: [
    // Angular
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,

    // Third Party
    BlockUIModule.forRoot(),
    NgbAlertModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    UIRouterUpgradeModule,

    // Custom
    ComponentsModule,
    ControlsModule,
    DirectivesModule,
    PipesModule,
    ValidatorsModule
  ]
})
export class SharedModule {
  constructor (
    private ngbModalConfig: NgbModalConfig
  ) {
    /**
     * global configuration options for
     * ngbModal.
     * TODO: Move configs to their own file(s)
     */
    this.ngbModalConfig.backdrop = 'static';
    this.ngbModalConfig.keyboard = false;
  }
}

